import { defineComponent as _defineComponent } from 'vue'
import { Exercise, UnknownExercise } from '@ilteducation/exercise-service-types';
import { computed, getCurrentInstance, ref, watch } from 'vue';
import Form from '@/resources/exercises/Form.vue';
import useExerciseCopyPaste from '@/comp/use-exercise-copy-paste';
import eventBus from '@/foundations/services/eventBus';
import { getTitle } from '@/foundations/helpers/videoUtils';
import VideoExercisesTable from '@/components/exercise/VideoExercisesTable.vue';
import { VideoMarket } from '@ilteducation/content-registry-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoExercises',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as { item: any }



const exerciseTemplate: UnknownExercise = {
  type: 'quiz',
  resourceId: '',
  resourceType: 'video',
  title: '[New Quiz]',
  author: { name: 'ILT Education', type: 'alias' },
  content: [],
};

const markets: { name: string; code: VideoMarket; lang: string }[] = [
  {
    name: 'Sweden',
    code: 'se',
    lang: 'sv',
  },
  {
    name: 'Finland',
    code: 'fi',
    lang: 'fi',
  },
  {
    name: 'Norway',
    code: 'no',
    lang: 'nb',
  },
];

const exercises = ref<UnknownExercise[]>([]);
const exercisesForms = ref([]);

const getMarketFromResourceId = (resourceId: string) =>
  resourceId.split('-')[1] ??
  Object.keys(props.item.introfilmsUids).find((market) =>
    Object.values(props.item.introfilmsUids[market]).includes(resourceId),
  );

const dialog = ref(false);

const selectedMarket = ref<string>(markets[0].code);
watch(selectedMarket, (market) => {
  if (market) {
    exercisesForms.value.forEach((form) => {
      exercises.value = exercises.value.map((ex) => ({
        ...ex,
        ...form.$children[0].formState.model,
        resourceId: `${props.item.id}-${market}`,
      }));
    });
  }
});

const videoResourceIds = ref([
  ...markets.map((market) => `${props.item.id}-${market.code}`),
  ...(Object.keys(props.item.introfilmsUids)
    .map((market) => Object.values(props.item.introfilmsUids[market]))
    .flat() as string[]),
]);

const { parsedExercises, toggle, clipboardHandler } = useExerciseCopyPaste(() => {
  const newExercises = parsedExercises.value
    .map((parsedExercise) => ({
      ...exerciseTemplate,
      ...parsedExercise,
      resourceId: `${props.item.id}-${selectedMarket.value}`,
    }))
    .filter(
      (exerciseToAdd) =>
        !exercises.value
          .map((existedExercise) => JSON.stringify(existedExercise))
          .includes(JSON.stringify(exerciseToAdd)),
    );
  exercises.value.push(...newExercises);
  eventBus.$emit(
    'snackbar.open',
    newExercises.length ? `${newExercises.length} exercises added!` : 'No exercise to add.',
  );
});

const saveExercises = () => {
  exercisesForms.value.forEach((exerciseForm) => {
    const formState = exerciseForm?.$children?.[0]?.formState;
    if (formState && formState.model.type === 'quiz') {
      formState.model.sort = formState.model.title.match(/Quiz (\d+)/)[1];
    }
    if (formState) {
      formState.submit();
    }
  });
  // submit() is a void method on formState, and it doesn't return a Promise
  // triggering exercises <va-list> reload to show newly created items
  const copy = videoResourceIds.value.slice();
  videoResourceIds.value = [''];
  setTimeout(() => {
    videoResourceIds.value = copy;
  }, 1000);

  exercisesForms.value = [];
  exercises.value = [];
  dialog.value = false;
};

watch(dialog, (value) => {
  toggle(value);
});

const store = ref<any>();
const useStore = () => {
  const vm = getCurrentInstance()!.proxy;
  store.value = vm.$store;
};
useStore();
const currentExerciseList = ref<Exercise[]>([]);
store.value
  .dispatch('exercises/getList', {
    filter: {
      resourceId: videoResourceIds.value,
    },
  })
  .then((response: { data: Exercise[] }) => {
    currentExerciseList.value = response.data;
  });

const exercisesPerMarket = computed(() => {
  const perMarket = currentExerciseList.value.reduce((acc: Record<string, Exercise[]>, exercise: Exercise) => {
    const market = getMarketFromResourceId(exercise.resourceId);
    if (market) {
      if (!acc[market]) {
        // eslint-disable-next-line no-param-reassign
        acc[market] = [];
      }
      acc[market].push(exercise);
    }
    return acc;
  }, {});

  Object.values(perMarket).forEach((subjectExercises) => {
    subjectExercises.sort((a, b) => {
      // sort quizzes by sort order at the end of the list, all other exercises at the beginning
      if (a.sort && b.sort) {
        return a.sort - b.sort;
      }
      if (a.sort) {
        return 1;
      }
      if (b.sort) {
        return -1;
      }
      return 0;
    });
  });
  return perMarket;
});

return { __sfc: true,props, exerciseTemplate, markets, exercises, exercisesForms, getMarketFromResourceId, dialog, selectedMarket, videoResourceIds, parsedExercises, toggle, clipboardHandler, saveExercises, store, useStore, currentExerciseList, exercisesPerMarket, Form, getTitle, VideoExercisesTable }
}

})